import { Alert } from '@mantine/core';

import { describeFailure } from './describeFailure';

export function ErrorState({ error }: { error: unknown }) {
  return (
    <Alert color="red" role="alert">
      {describeFailure(error)}
    </Alert>
  );
}
